import { LoginSecurity } from "../LoginSecurity"
export const Home = () => {
  return (
    <>
      <LoginSecurity />
    </>
  )
}
